import React, { useState } from "react";
import { toast } from "sonner";
import { LegalLayout, Section } from "@/components/LegalLayout";

export default function Cookies() {
  const [consent, setConsent] = useState(() => localStorage.getItem("sb_cookie_consent") || "—");

  const resetConsent = () => {
    localStorage.removeItem("sb_cookie_consent");
    setConsent("—");
    toast.success("Cookie-Einwilligung zurückgesetzt. Der Hinweis erscheint beim nächsten Laden erneut.");
  };

  return (
    <LegalLayout title="Cookie-Richtlinie" testid="cookies-page">
      <Section title="1. Was sind Cookies?">
        <p>Cookies bzw. vergleichbare Techniken (z. B. Local Storage) sind kleine Datenmengen, die in deinem Browser gespeichert werden, damit eine Website ordnungsgemäß funktioniert und Einstellungen erhalten bleiben.</p>
      </Section>

      <Section title="2. Welche Cookies wir verwenden">
        <p>SafeBuddy verwendet ausschließlich <b>technisch notwendige</b> Einträge. Es findet <b>kein Tracking</b>, keine Analyse und keine Werbung durch Dritte statt.</p>
        <ul className="list-disc pl-5 space-y-1">
          <li><b>sb_token</b> – hält deine Anmeldung aufrecht (Login-Sitzung).</li>
          <li><b>sb_lang</b> – speichert deine gewählte Sprache.</li>
          <li><b>sb_theme</b> – speichert das gewählte Farbdesign.</li>
          <li><b>sb_cart</b> – merkt sich deinen Warenkorb im Shop.</li>
          <li><b>sb_cookie_consent</b> – speichert deine Entscheidung zum Cookie-Hinweis.</li>
        </ul>
      </Section>

      <Section title="3. Zweck">
        <p>Diese Einträge sind erforderlich, um Kernfunktionen bereitzustellen: Anmeldung, Spracheinstellung, Warenkorb und die Speicherung deiner Cookie-Entscheidung. Ohne sie kann die App nicht bzw. nur eingeschränkt genutzt werden. Eine Einwilligung ist für technisch notwendige Cookies rechtlich nicht erforderlich.</p>
      </Section>

      <Section title="4. Opt-out und Kontrolle">
        <p>Du kannst Cookies jederzeit über die Einstellungen deines Browsers ansehen, blockieren oder löschen. Bitte beachte, dass die App bei Deaktivierung technisch notwendiger Cookies nicht mehr korrekt funktioniert (z. B. Anmeldung nicht möglich).</p>
      </Section>

      <Section title="5. Einwilligung verwalten">
        <p>Aktueller Status deiner Cookie-Entscheidung: <b data-testid="cookie-consent-status">{consent === "accepted" ? "Akzeptiert" : consent === "rejected" ? "Abgelehnt" : "Noch nicht getroffen"}</b>.</p>
        <button data-testid="reset-cookie-consent" onClick={resetConsent} className="sb-btn mt-1 px-4 py-2 bg-white font-medium text-sm">Cookie-Einstellungen zurücksetzen</button>
      </Section>
    </LegalLayout>
  );
}
